<template>
<wt-table :labels="tableLabels" :list="data">
  <template>
    <el-table-column label="配置参数对象">
      <template slot-scope="scope">
        <div :class="scope.row.isOpen?'':$style['fold-class']">{{scope.row.config||'--'}}</div>
        <el-button v-if="scope.row.config&&scope.row.config.length>120" type="text"
          @click="openOrClose(scope.row)">{{scope.row.isOpen?'折叠':"展开"}}</el-button>
      </template>
    </el-table-column>
  </template>
</wt-table>
</template>
<script>
export default {
  props: {
    data: {
      type: [Object, Array],
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      tableLabels: [
        {
          label: '支付渠道',
          value: 'channel_show'
        },
        {
          label: '支付渠道驱动',
          value: 'driver'
        },
        {
          label: 'web端是否可用',
          value: 'forEndUser'
        }
      ]
    }
  },
  methods: {
    openOrClose (row) {
      this.$set(row, 'isOpen', !row.isOpen)
    }
  }
}
</script>
<style module lang="less">
.fold-class{
  overflow: hidden;
  text-overflow: ellipsis;
   display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;

}
</style>
